export const INTERNAL_ERROR_MSG = "500 - Something went wrong";
export const FORBIDDEN_ERROR_MSG = "403 - Forbidden";
export const RESOURCE_ALREADY_EXISTS = "409 - Resource already exists";

// Filters
export const dropdownMenu = [
  "All",
  "LastHour",
  "CurrentDay",
  "ThisWeek",
  "ThisMonth",
  "Custom",
];

export enum appSettingsId {
  LOG_DELETE_FREQUENCY = "D958159A-2819-45AE-8D51-8E41CE979FFB",
  ALERT_LOG_DELETE_FREQUENCY = "CA9C8B6B-65C6-48F8-B92B-27994308BFEF"
}

export const missingMTCSteps = [
  { key: 'fetchingBlob', label: 'Blob Received' },
  { key: 'noMTCFound', label: 'MessageTypeCode not found' },
];

export const calculateUsageSteps = [
  { key: 'fetchingBlob', label: 'Blob Received' },
  { key: 'Validating', label: 'Xml Validation' },
  { key: 'savingData', label: 'Saved to DB' },
  { key: 'calculatingUsage', label: 'Calculating Usage' },
  { key: 'savingUsage', label: 'Saved Usage to DB' },
  { key: 'notifyNewVersion', label: 'Notified Skybill', optional: true }, // optional step
  { key: 'blobProcessed', label: 'Blob Processed' },
  { key: 'movingBlob', label: 'Blob moved' }
];

export const passthroughSteps = [
  { key: 'fetchingBlob', label: 'Blob Received' },
  { key: 'blobProcessed', label: 'Passthrough successful' }
];

export const parseXmltoDBSteps = [
  { key: 'fetchingBlob', label: 'Blob Received' },
  { key: 'Validating', label: 'Xml Validation' },
  { key: 'dstChangeDetected', label: 'DST Change Detected' },
  { key: 'savingData', label: 'Saved to DB' },
  { key: 'notifyNewVersion', label: 'Notified Skybill', optional: true }, // optional step
  { key: 'blobProcessed', label: 'Blob Processed' },
  { key: 'movingBlob', label: 'Blob moved' }
];

export const estimateUsageSteps = [
  { key: 'fetchingData', label: 'Starting Estimation' },
  { key: 'estimatingUsage', label: 'Estimation Calculation' },
  { key: 'savingEstimatedData', label: 'Saved to DB' }
]

export const estimateUsageParallelSteps = [
  { key: 'estimatingUsage', label: 'Starting Estimation' },
]

export const recalculateUsageSteps = [
  { key: 'recalculateEstimates', label: 'Starting Recalculation' },
  { key: 'savingRecalculatedEstimates', label: 'Recalculation Saved to DB' }
]

export const sftpToBlobSteps = [
  { key: 'InitialiseDestination', label: 'Initialise Destination' },
  { key: 'InitialiseSftp', label: 'Initialise SFTP' },
  { key: 'DownloadFile', label: 'File Downloaded' },
  { key: 'UploadFile', label: 'File Uploaded' },
  { key: 'TaskResult', label: 'Success' }
];

export const withdrawalSteps = [
  { key: 'fetchingBlob', label: 'Blob Received' },
  { key: 'Validating', label: 'Xml Validation' },
  { key: 'savingData', label: 'Saved to DB' },
  { key: 'withdrawal', label: 'Withdrawal' },
  { key: 'blobProcessed', label: 'Blob Processed' },
  { key: 'movingBlob', label: 'Blob moved' }
];

export const dayAheadSteps = [
  { key: 'fetchingBlob', label: 'Blob Received' },
  { key: 'validating', label: 'Csv Validation' },
  { key: 'savingData', label: 'Saved to DB' },
  { key: 'blobProcessed', label: 'Blob Processed' },
  { key: 'movingBlob', label: 'Blob moved' }
];

export const taskTypes = [
  "CalculateUsage",
  "DayAheadParseCsv",
  "EstimatingUsage",
  "EstimatingUsageParallel",
  "ParseXmltoDB",
  "Passthrough",
  "RecalculatingEstimates",
  "SFTPtoBlob",
  "Withdrawal"
];

export const fileTypes = [
  "010", "011", "011A", "012", "012W", "013", "014R", "015", "016", "017", "021", "030",
  "101", "101P", "101R", "102", "102P", "102R", "105", "105L", "106D", "106E", "110", "111",
  "111A", "111L", "111R", "112", "112R", "112W", "114", "115", "115R", "116", "116A", "116N",
  "116R", "117D", "117R", "122", "122R", "130D", "130R", "131", "137R", "140", "208", "210",
  "252", "260", "261", "300", "300S", "300W", "301", "301N", "303R", "305", "306", "306W",
  "307", "307W", "308", "310", "310W", "311", "320", "320W", "321", "322", "330", "331",
  "332", "332W", "341", "342", "343", "344", "345", "352R", "507", "507C", "591", "592", "594",
  "595", "596", "597", "598", "601", "602", "700", "700W", "701", "701W", "999", "DAP"
];

export const statusTypes = [
  "Success", "Failed"
]

export const containerNamesByPipeline = new Map<string, string>([
  ["CalculateUsage", 'AzureBlobProcessing'],
  ["RecalculatingEstimates", 'AzureBlobProcessing'],
  ["EstimatingUsage", 'AzureBlobProcessing'],
  ["Withdrawal", 'AzureBlobProcessing'],
  ["Passthrough", 'AzureBlobProcessing'],
  ["ParseXmltoDB", 'AzureBlobProcessing'],
  ["DayAheadParseCsv", 'AzureDayAheadCleanDmz']
]);